import { render, staticRenderFns } from "./UploadTest.vue?vue&type=template&id=2e29ea7c&scoped=true"
import script from "./UploadTest.vue?vue&type=script&lang=js"
export * from "./UploadTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e29ea7c",
  null
  
)

export default component.exports